"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _favicon = _interopRequireDefault(require("bender-url!../../img/favicon.png"));

var _faviconDark = _interopRequireDefault(require("bender-url!../../img/favicon-dark.png"));

var getFavicon = function getFavicon() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? _faviconDark.default : _favicon.default;
};

var Favicon = function Favicon(_ref) {
  var rel = _ref.rel,
      type = _ref.type;
  return _react.default.createElement("link", {
    rel: rel,
    type: type,
    href: getFavicon()
  });
};

Favicon.propTypes = {
  type: _propTypes.default.string.isRequired,
  rel: _propTypes.default.string.isRequired
};
Favicon.defaultProps = {
  rel: 'shortcut icon',
  type: 'image/png'
};
var _default = Favicon;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Favicon.js
// module id = 161
// module chunks = 0